import { useIntl } from 'react-intl'
import PropTypes from 'prop-types'
import SwitchComponent from '../stories/atoms/switch'
import { ShowInactiveContainer, ShowInactiveLabel } from './styled-component'

// Shared by plan-menu and project-menu (company-projects); each caller
// passes its own label so the copy matches what's actually being filtered.
const ShowInactiveSwitch = ({
  onCheckedChange = () => {},
  checked = false,
  disabled = false,
  label
}) => {
  const { formatMessage } = useIntl()

  return (
    <ShowInactiveContainer>
      <ShowInactiveLabel data-checked={checked} data-disabled={disabled}>
        {label ?? formatMessage({ id: 'show_inactive_projects' })}
      </ShowInactiveLabel>
      <SwitchComponent
        checked={checked}
        disabled={disabled}
        onCheckedChange={onCheckedChange}
      />
    </ShowInactiveContainer>
  )
}

ShowInactiveSwitch.propTypes = {
  onCheckedChange: PropTypes.func,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  label: PropTypes.string
}

export default ShowInactiveSwitch
